import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import { useToast } from "hooks";
import phaseValidationSchema from "features/account/schemas/phaseValidationSchema";
import RequiredAsterisk from "components/ui/RequiredAsterisk";
import { useCreatePhase } from "features/account/services";
import ErrorHandler from "components/ui/ErrorHandler";

const PhaseCreate = ({ onPhaseCreated, isCreateButtonDisabled }) => {
  const toast = useToast();
  const [show, setShow] = useState(false);

  const { error, isLoading, createPhase } = useCreatePhase({
    onPhaseCreated: () => {
      toast.success("Success", "The phase has been created successfully");
      handleClose();
      onPhaseCreated();
    },
  });

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
      <Button onClick={handleShow} disabled={isCreateButtonDisabled} size="sm">
        <span translate="no" className="material-symbols-outlined md-16">
          add
        </span>
        Add Phase
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Create Phase</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={phaseValidationSchema}
            initialValues={{
              name: "",
            }}
            onSubmit={(values) => createPhase(values)}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              isValid,
              errors,
            }) => (
              <Form>
                <Form.Group controlId="name">
                  <Form.Label>
                    Phase name <RequiredAsterisk />
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder="Phase name"
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    isValid={values.name && !errors.name}
                    isInvalid={!(values.name && !errors.name) && touched.name}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.name && touched.name ? (
                      <small>{errors.name}</small>
                    ) : null}
                  </Form.Control.Feedback>
                </Form.Group>
                {error && <ErrorHandler error={error} />}
                <div className="text-end mt-3">
                  <Button
                    size="sm"
                    variant="outline-primary"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    size="sm"
                    className="float-end px-3 ms-3"
                    onClick={handleSubmit}
                    disabled={isLoading || !isValid || !values.name}
                  >
                    {isLoading && (
                      <Spinner
                        className="me-2"
                        animation="border"
                        size="sm"
                        variant="light"
                      />
                    )}{" "}
                    Create Phase
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PhaseCreate;
